import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e496d4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Login", -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "input-group" }
const _hoisted_5 = { class: "input-group" }
const _hoisted_6 = { class: "input-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseInput = _resolveComponent("BaseInput")!
  const _component_BaseAlert = _resolveComponent("BaseAlert")!
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("form", {
    class: "account-login",
    onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      (_ctx.enableCreate)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
            _createTextVNode(" Don't have an account? Register "),
            _createElementVNode("a", {
              href: "#",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToRegister()))
            }, "here"),
            _createTextVNode(". ")
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["input-group email", { selected: _ctx.emailLocked }])
    }, [
      _createVNode(_component_BaseInput, {
        label: _ctx.isAgent ? 'Enter your agent credentials' : (_ctx.enableCreate ? 'Enter your e-mail address' : 'E-mail or customer profile number'),
        disabled: _ctx.emailLocked,
        hasError: _ctx.v$.userName.$error,
        errors: _ctx.v$.userName.$errors,
        valid: !_ctx.v$.userName.$invalid,
        modelValue: _ctx.v$.userName.$model,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.userName.$model) = $event)),
        name: "userName"
      }, null, 8, ["label", "disabled", "hasError", "errors", "valid", "modelValue"]),
      (_ctx.emailLocked)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            href: "#",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.unlockEmail()))
          }, "Change"))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_BaseInput, {
        type: "password",
        label: "Password",
        hasError: _ctx.v$.password.$error,
        errors: _ctx.v$.password.$errors,
        valid: !_ctx.v$.password.$invalid,
        modelValue: _ctx.v$.password.$model,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.v$.password.$model) = $event)),
        ref: "passwordRef",
        name: "password"
      }, null, 8, ["hasError", "errors", "valid", "modelValue"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("a", {
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.goToForgotPassword && _ctx.goToForgotPassword(...args))),
        href: "#"
      }, "Forgotten password?")
    ]),
    (_ctx.error)
      ? (_openBlock(), _createBlock(_component_BaseAlert, {
          key: 0,
          message: _ctx.error,
          type: "danger"
        }, null, 8, ["message"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_BaseButton, { loading: _ctx.loading }, {
        default: _withCtx(() => [
          _createTextVNode("Login")
        ]),
        _: 1
      }, 8, ["loading"])
    ])
  ], 32))
}